<template>
  <div>
    <div
      data-test="modal-header"
      class="text-md font-semibold modal-header"
    >
      <button
        v-if="backTarget"
        class="back-button button-reset"
        data-test="back-button"
        @click="back"
      >
        <icon name="arrow-left-uui" variant="181d27" />
      </button>
      <span class="text-xl">{{ headerText }}</span>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon';

export default {
  name: 'ProfileModalHeader',
  components: {
    Icon,
  },
  props: {
    backTarget: {
      type: String,
      default: '',
    },
    headerText: {
      type: String,
      default: 'Default Header',
    },
  },
  methods: {
    back() {
      this.$store.commit('ui/setProfileModalShown', this.backTarget);
    },
  },
};
</script>

<style scoped lang="scss">
.modal-header {
  align-items: center;
  color: black;
  display: flex;
  gap: 1rem;
  justify-content: flex-start;
  min-width: 536px;
  padding: 1.344rem 0;
  text-align: center;
}

@include breakpoint(tablet) {
  .modal-header {
    background-color: transparent;
  }
}

@include breakpoint(desktop) {
  .modal-header {
    background-color: transparent;
  }
}
</style>
